import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ContactLeadModal from '../components/LandingComponents/ContactLeadModal';

const LeadCaptureContext = createContext(null);

export function LeadCaptureProvider({ children }) {
  const location = useLocation();
  const [modalState, setModalState] = useState({
    isOpen: false,
    variant: 'demo',
    source: 'unknown',
  });

  const closeModal = useCallback(() => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const openDemoModal = useCallback(({ source = 'unknown' } = {}) => {
    setModalState({ isOpen: true, variant: 'demo', source });
  }, []);

  const openWaitlistModal = useCallback(({ source = 'unknown' } = {}) => {
    setModalState({ isOpen: true, variant: 'optrim_waitlist', source });
  }, []);

  const value = useMemo(
    () => ({
      openDemoModal,
      openWaitlistModal,
      closeModal,
    }),
    [openDemoModal, openWaitlistModal, closeModal]
  );

  return (
    <LeadCaptureContext.Provider value={value}>
      {children}
      <ContactLeadModal
        isOpen={modalState.isOpen}
        variant={modalState.variant}
        source={modalState.source}
        page={location.pathname}
        onClose={closeModal}
      />
    </LeadCaptureContext.Provider>
  );
}

export function useLeadCapture() {
  const context = useContext(LeadCaptureContext);
  if (!context) {
    throw new Error('useLeadCapture debe usarse dentro de LeadCaptureProvider');
  }
  return context;
}
